module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "quartz-core": "static-1.6382"
    },
    "depPathPrefixes": {
      "quartz-core": "/quartz-core/static-1.6382"
    },
    "bundlingPackage": "documents-public-ui",
    "bundlingPackageVersion": "static-1.34776",
    "project": "quartz-core",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};